<template>
  <div class="careworkers">
    <careworkersList ref="list"></careworkersList>
    <router-view @list-reload="listReload"></router-view>
  </div>
</template>

<script>
import careworkersList from './careworkersList.vue'

export default {
  components: {
    careworkersList
  },
  methods: {
    async listReload() {
      await this.$refs.list.reload()
    }
  }
}
</script>
<style scoped>
.careworkers {
  height: 100%;
  overflow-wrap: anywhere;
}
</style>



// WEBPACK FOOTER //
// src/components/careworkers/careworkers.vue